import { render, staticRenderFns } from "./ModifyCommunication.vue?vue&type=template&id=7bc0d020&scoped=true"
import script from "./ModifyCommunication.vue?vue&type=script&lang=js"
export * from "./ModifyCommunication.vue?vue&type=script&lang=js"
import style0 from "./ModifyCommunication.vue?vue&type=style&index=0&id=7bc0d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0d020",
  null
  
)

export default component.exports